import React from 'react'
import { EmptyCard } from '../../common/EmptyCard'
import { Table, TableHeading, TableCell } from '../../atoms/Table'
import { A } from '../../atoms/A'
import { CheckIcon } from '../../atoms/CheckIcon'
import { css } from '@emotion/react'
import { PersonGlobalSearchResult } from '../../../types'

type Props = {
  list: PersonGlobalSearchResult[]
}

export const SearchPeopleTable: React.FC<Props> = (props) => {
  if (props.list.length === 0) {
    return <EmptyCard />
  }

  return (
    <Table>
      <thead>
        <tr>
          <TableHeading>名前</TableHeading>
          <TableHeading>スタートアップ</TableHeading>
          <TableHeading>投資家</TableHeading>
          <TableHeading>現所属企業</TableHeading>
        </tr>
      </thead>
      <tbody>
        {props.list.map((person, i) => (
          <tr key={i} data-test-id="person-item">
            <TableCell>
              <A href={person.path} target="_blank" decoration="none">
                {person.name}
              </A>
            </TableCell>
            <TableCell>{person.startupMember && <CheckIcon />}</TableCell>
            <TableCell>{person.investorMember && <CheckIcon />}</TableCell>
            <TableCell>
              {person.belongings && (
                <>
                  {person.belongings.length > 0 && (
                    <A
                      href={person.belongings[0].path}
                      target="_blank"
                      decoration="none"
                    >
                      {person.belongings[0].name}
                    </A>
                  )}
                  {person.belongings.length > 1 && (
                    <span
                      css={css`
                        padding-left: 3px;
                      `}
                    >
                      他{person.belongings.length - 1}社
                    </span>
                  )}
                </>
              )}
            </TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
